import React, { Component } from "react";

export class SearchComponentOpenData extends Component {
    render() {
        return (
            <section id="hero" className="d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center pt-5 pt-lg-0" data-aos="fade-up">
                            <div>
                                <h1>Sampang Satu Data </h1>
                                <h1 className="font-weight-100">Website Resmi Pemerintah<br /> Kabupaten Sampang </h1><br />
                                <h2>Jelajahi kumpulan Data terbuka di Kabupaten Sampang <br /> untuk meningkatkan aksesibilitas informasi dan mempromosikan transparansi <br />dengan menyediakan akses ke Data yang relevan <br />dan penting untuk masyarakat.</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default SearchComponentOpenData;